(function(config) {
    'use strict';

    angular.module('notes.services', [
            'ngResource'
        ])
        .factory('notesDataSrvc', notesDataSrvc)
        .factory('noteModalSrvc', noteModalSrvc);

    notesDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function notesDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/notes/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
            },
            update: {
                method: 'PATCH',
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    noteModalSrvc.$inject = ['$uibModal', 'modalSrvc', 'notesDataSrvc', 'notificationSrvc', 'notesMessagesConst'];

    function noteModalSrvc($uibModal, modalSrvc, notesDataSrvc, notificationSrvc, notesMessagesConst) {
        return {
            modal: modal,
            remove: remove
        };

        function modal(order, note, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/notes/views/note-modal/note-modal.html',
                controller: 'NoteModalController',
                controllerAs: 'ctrl',
                size: 'md',
                windowClass: 'note-modal',
                resolve: {
                    dataObj: function () {
                        return {
                            order: order,
                            note: note
                        };
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

        function remove(dataObj, successCallback, errorCallback) {
            modalSrvc.confirmRemove('notatkę',
                function() {
                    notesDataSrvc.delete({pk: dataObj.pk}).$promise.then(
                        function(response) {
                            notificationSrvc.notification("success", notesMessagesConst.delete);
                            return (successCallback || angular.noop)(response);
                        },
                        function(response) {
                            var message = (response.data && response.data.detail) || notesMessagesConst.error;
                            notificationSrvc.notification("error", message);
                            return (errorCallback || angular.noop)(response);
                        }
                    );
                }
            );
        }
    }
})(window.config);
